<template>
  <div class="official-invite-code">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="form" label-width="70px" @submit.native.prevent>
        <div class="query-form-container" style="display:flex;flex-wrap:wrap;align-items:flex-start;gap:10px;">
          <el-form-item label="邀请码">
            <el-input v-model.trim="form.inviteCode" clearable placeholder="请输入邀请码" style="width:160px;" />
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="form.createdAt"
              type="datetime"
              placeholder="选择创建时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              style="width:190px;"
            />
          </el-form-item>
          <el-form-item>
            <div class="button-group" style="display:flex;flex-wrap:wrap;gap:6px;">
              <el-button type="primary" :loading="loading" @click="handleSearch" icon="el-icon-search">查询</el-button>
              <el-button type="success" :loading="loading" @click="handleAdd" icon="el-icon-plus">新增</el-button>
              <el-button type="info" plain @click="handleReset" :disabled="loading" icon="el-icon-refresh">重置</el-button>
            </div>
          </el-form-item>
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在查询..."
        class="animate__animated animate__fadeIn"
      >
        <el-table-column prop="inviteCode" label="邀请码" min-width="180" />
        <el-table-column prop="isActive" label="状态" min-width="100" :formatter="statusFormatter" align="center" />
        <el-table-column prop="createdAt" label="创建时间" min-width="170" :formatter="timeFormatter" />
        <el-table-column label="操作" min-width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px">
      <el-form :model="dialogForm" label-width="100px">
        <el-form-item label="邀请码" :required="true">
          <el-input v-model="dialogForm.inviteCode" :disabled="isEdit" placeholder="请输入邀请码" />
        </el-form-item>
        <el-form-item label="状态" :required="true">
          <el-select v-model="dialogForm.isActive" placeholder="请选择状态">
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="dialogLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/http.js'

export default {
  name: 'OfficialInviteCode',
  data() {
    return {
      form: {
        inviteCode: '',
        createdAt: ''
      },
      loading: false,
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 弹窗相关
      dialogVisible: false,
      dialogLoading: false,
      isEdit: false,
      dialogForm: {
        inviteCode: '',
        isActive: 1
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑官方邀请码' : '新增官方邀请码'
    }
  },
  methods: {
    timeFormatter(row, column, cellValue) {
      if (!cellValue) return ''
      return String(cellValue).replace('T', ' ')
    },
    statusFormatter(row, column, cellValue) {
      return cellValue === 1 ? '启用' : '禁用'
    },
    handleReset() {
      this.form = {
        inviteCode: '',
        createdAt: ''
      }
      this.pagination.pageNum = 1
      this.fetchData()
    },
    async handleSearch() {
      this.pagination.pageNum = 1
      await this.fetchData()
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page
      this.fetchData()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      try {
        let url = `/admin/officialInviteCode/list?pageNum=${this.pagination.pageNum}&pageSize=${this.pagination.pageSize}`
        
        if (this.form.inviteCode) {
          url += `&inviteCode=${encodeURIComponent(this.form.inviteCode)}`
        }
        if (this.form.createdAt) {
          url += `&createdAt=${encodeURIComponent(this.form.createdAt)}`
        }

        const result = await request(url, { method: 'GET' })
        
        if (result && result.code === 200 && result.data) {
          const data = result.data
          this.tableData = Array.isArray(data.records) ? data.records : []
          this.pagination.total = data.total || 0
          this.pagination.pageSize = data.size || this.pagination.pageSize
          this.pagination.pageNum = data.current || this.pagination.pageNum
        } else {
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        this.$message.error('查询失败：' + error.message)
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.isEdit = false
      this.dialogForm = {
        inviteCode: '',
        isActive: 1
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.dialogForm = {
        inviteCode: row.inviteCode,
        isActive: row.isActive
      }
      this.dialogVisible = true
    },
    async handleSave() {
      if (!this.dialogForm.inviteCode) {
        this.$message.error('请输入邀请码')
        return
      }

      this.dialogLoading = true
      try {
        let url, method
        
        if (this.isEdit) {
          url = '/admin/officialInviteCode/update'
          method = 'PUT'
        } else {
          url = '/admin/officialInviteCode/add'
          method = 'POST'
        }

        const result = await request(url, {
          method: method,
          body: JSON.stringify(this.dialogForm)
        })

        if (result && result.code === 200) {
          this.$message.success(result.msg || '操作成功')
          this.dialogVisible = false
          this.fetchData()
        } else {
          this.$message.error(result.msg || '操作失败')
        }
      } catch (error) {
        this.$message.error('操作失败：' + error.message)
      } finally {
        this.dialogLoading = false
      }
    },
    handleDelete(row) {
      this.$confirm('确定要删除这个邀请码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const result = await request(`/admin/officialInviteCode/delete/${row.inviteCode}`, {
            method: 'DELETE'
          })
          
          if (result && result.code === 200) {
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(result.msg || '删除失败')
          }
        } catch (error) {
          this.$message.error('删除失败：' + error.message)
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>
.official-invite-code {
}

.query-form-container {
  margin-bottom: 16px;
}

.button-group {
  display: flex;
  gap: 8px;
}

.pagination-container {
  margin-top: 16px;
  text-align: right;
}
</style>